/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

/**
 * Majority of this CSS will be able to be removed once :has-slotted is widely supported
 * https://developer.mozilla.org/en-US/docs/Web/CSS/:has-slotted
 * https://chromestatus.com/feature/5134941143433216
 */

[nve-control]:not([nofocus]):has(*:focus-visible)::part(_input) {
  outline: Highlight solid 2px !important;
  outline: 5px auto -webkit-focus-ring-color !important;
}

[nve-control] input::placeholder,
[nve-control] textarea::placeholder {
  color: var(--nve-sys-text-placeholder-color) !important;
}

[nve-control] input::-webkit-search-cancel-button,
[nve-control] input::-webkit-calendar-picker-indicator {
  opacity: 0 !important;
  display: none !important;
}

[nve-control]:has([nve-control]) {
  --control-type: custom;
}

[nve-control]:not(:has(label))::part(_label) {
  display: none !important;
}

[nve-control]:not(:has(nve-control-message:not([hidden])))::part(_messages) {
  display: none !important;
}

/** block controls */
[nve-control='']:has(label)::part(_internal-host) {
  grid-template-areas:
    'label label label'
    'input input input';
}

[nve-control='']:has(nve-control-message:not([hidden]))::part(_internal-host) {
  grid-template-areas:
    'input input input'
    'messages messages messages';
}

[nve-control='']:has(label):has(nve-control-message:not([hidden]))::part(_internal-host) {
  grid-template-areas:
    'label label label'
    'input input input'
    'messages messages messages';
}

[nve-control=''][layout='horizontal']:has(nve-control-message:not([hidden]))::part(_internal-host),
[nve-control=''][layout='horizontal-inline']:has(nve-control-message:not([hidden]))::part(_internal-host) {
  grid-template-areas:
    'label input input'
    '. messages messages';
}

[nve-control=''][layout='horizontal']:not(:has(nve-control-message:not([hidden])))::part(_internal-host),
[nve-control=''][layout='horizontal-inline']:not(:has(nve-control-message:not([hidden])))::part(_internal-host) {
  grid-template-areas: 'label input input';
}

/** inline controls */
[nve-control='inline']:has(label)::part(_internal-host) {
  grid-template-areas: 'input label label';
}

[nve-control='inline']:has(nve-control-message:not([hidden]))::part(_internal-host) {
  grid-template-areas:
    'input input input'
    'messages messages messages';
}

[nve-control='inline']:has(label):has(nve-control-message:not([hidden]))::part(_internal-host) {
  grid-template-areas:
    'input label label'
    'messages messages messages';
}

[nve-control='inline']:not(:has(nve-control-message:not([hidden])))::part(_internal-host) {
  grid-template-areas: 'input label label';
}

[nve-control='inline']:not(:has(label), :has(nve-control-message:not([hidden])))::part(_internal-host) {
  grid-template-areas: 'input input input';
}

/* customizations for first-party elements */
nve-control:has(nve-monaco-input),
nve-control:has(nve-monaco-diff-input) {
  contain: none;
}

[prominence='muted'] > [nve-control]:state(checked),
[prominence='muted'][nve-control]:state(checked) {
  --filter: grayscale(90%);
}
